const dataSourceTypeTranslation: Record<string, string> = {
    AUTOMATIC: "Automatyczny",
    MANUAL: "Ręczny"
};

export const transformDataSources = (dataSources: any[]): any[] => {
    return dataSources.map(dataSource => ({
        ...dataSource,
        dataSourceType: dataSourceTypeTranslation[dataSource.dataSourceType],
    }));
};
